const ITEMS = [
  "VVIP · By Special Invitation Only",
  "Detroit × South Africa",
  "The Choice Summit",
  "Detroit · October 27, 2026",
  "The Edutainment Box × DABO",
  "30+ Vital Screenings · Under 3 Minutes",
];

const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/10 bg-charcoal/60 py-5">
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {[...row, ...row].map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-sm sm:text-base font-semibold uppercase tracking-[0.3em] text-white/55">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-brand-500" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
